import o from "styled-components";
import e from "../../../utils/colors.js";
import { device as r } from "../../../utils/device.js";
import n from "../../Icons/Upload.js";
import { Display as i } from "../styled.js";
const x = o.button`
  display: flex;
  align-self: center;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background-color: ${(t) => t.disabled ? e.darkGrey10 : e.white};
  outline: none;
  transition: border 0.24s ease-in-out;
  height: 50px;
  width: 100%;
  font-family: 'VIC';

  @media ${r.isDesktop} {
    height: 50px;
    border: solid 1px ${(t) => t.disabled ? e.darkGrey75 : e.orange};
    max-width: 256px;

    &:not(:disabled) {
      cursor: pointer;
    }

    &:focus:not(:active) {
      outline: 2px solid ${e.orange};
      background-color: ${e.blueGrey10};
    }
  }

  @media ${r.isTablet}, ${r.isMobile} {
    height: 64px;
    border: 2px dashed ${(t) => t.disabled ? e.darkGrey75 : e.blueGrey};
  }
`, g = o(n).attrs({
  fill: e.orange
})`
  width: 35px;
  height: 22px;
`, c = {
  Desktop: o(i.Desktop)`
    height: 24px;
    font-size: 18px;
    text-align: center;
    color: ${e.orange};
    margin-left: 18px;
    letter-spacing: -0.32px;
    font-weight: 600;
  `,
  Tablet: o(i.Tablet)`
    color: ${e.blueGrey};
    margin-left: 18px;
    letter-spacing: -0.32px;
    font-weight: 500;
    height: 24px;
    font-size: 18px;
    text-align: center;
  `,
  Mobile: o(i.Mobile)`
    color: ${e.blueGrey};
    margin-left: 24px;
    letter-spacing: -0.24px;
    font-weight: 500;
    height: 24px;
    font-size: 18px;
    text-align: center;
  `
};
export {
  c as ContentWrapper,
  g as Upload,
  x as Wrapper
};
